module.exports = __webpack_public_path__ + "static/media/msg-nofound.254029dd.svg";